import React from 'react'
import {Icon} from '@salesforce/retail-react-app/app/components/shared/ui'

const ChronoIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 41" width="40" height="41" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.49305 7.49305C10.8101 4.176 15.309 2.3125 20 2.3125C24.691 2.3125 29.1899 4.176 32.507 7.49305C35.824 10.8101 37.6875 15.309 37.6875 20C37.6875 24.691 35.824 29.1899 32.507 32.507C29.1899 35.824 24.691 37.6875 20 37.6875C15.309 37.6875 10.8101 35.824 7.49305 32.507C4.176 29.1899 2.3125 24.691 2.3125 20C2.3125 15.309 4.176 10.8101 7.49305 7.49305ZM20 5.3125C16.1046 5.3125 12.3688 6.85993 9.61437 9.61437C6.85993 12.3688 5.3125 16.1046 5.3125 20C5.3125 23.8954 6.85993 27.6312 9.61437 30.3856C12.3688 33.1401 16.1046 34.6875 20 34.6875C23.8954 34.6875 27.6312 33.1401 30.3856 30.3856C33.1401 27.6312 34.6875 23.8954 34.6875 20C34.6875 16.1046 33.1401 12.3688 30.3856 9.61437C27.6312 6.85993 23.8954 5.3125 20 5.3125Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.5 12.7188V20C21.5 20.8284 20.8284 21.5 20 21.5C19.1716 21.5 18.5 20.8284 18.5 20V12.7188H21.5Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.9393 18.9393C19.5251 18.3536 20.4749 18.3536 21.0607 18.9393L28.1213 26L26 28.1213L18.9393 21.0607C18.3536 20.4749 18.3536 19.5251 18.9393 18.9393Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ChronoIcon
